var map = {
	"./bot_agents.svg": "b150",
	"./bot_button_en.png": "ec83",
	"./bot_button_ja.png": "d6d9",
	"./bot_button_zh.png": "6b32",
	"./bot_chat.png": "85bf",
	"./chartGPT.jpg": "4bc8",
	"./fix_chat_man.png": "1870"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7293";